import { Box } from "@mui/material";
import Flex from "@/components/Flex";
import Text from "@/components/Text";
import {
  NAV_BAR_COLORS,
  NAV_BAR_LABELS,
  NAV_BAR_LAYOUT,
  NAV_BAR_TYPOGRAPHY,
} from "../nav-bar-constant";
import type { EcareApp } from "../nav-bar-types";

export interface AppSwitcherTileProps {
  app: EcareApp;
}

const AppSwitcherTile = ({ app }: AppSwitcherTileProps) => {
  const AppIcon = app.icon;
  const isNavigable = !!app.url && !app.isCurrent && !app.isWaitlisted;

  const linkProps = isNavigable
    ? {
        component: "a" as const,
        href: app.url,
        target: "_blank",
        rel: "noopener noreferrer",
      }
    : {};

  return (
    <Flex
      {...linkProps}
      flexDirection="column"
      alignItems="center"
      textAlign="center"
      gap={NAV_BAR_LAYOUT.APP_TILE_GAP}
      p={NAV_BAR_LAYOUT.APP_TILE_PADDING}
      borderRadius={NAV_BAR_LAYOUT.APP_TILE_RADIUS}
      sx={{
        textDecoration: "none",
        color: "inherit",
        ...(isNavigable && {
          "&:hover, &:focus-visible": {
            backgroundColor: NAV_BAR_COLORS.APP_TILE_HOVER_BG,
          },
        }),
      }}
    >
      <Flex
        alignItems="center"
        justifyContent="center"
        width={NAV_BAR_LAYOUT.APP_TILE_ICON_BOX}
        height={NAV_BAR_LAYOUT.APP_TILE_ICON_BOX}
        borderRadius={NAV_BAR_LAYOUT.APP_TILE_RADIUS}
        bgcolor={app.color}
      >
        <AppIcon
          sx={{
            fontSize: NAV_BAR_LAYOUT.APP_TILE_ICON_SIZE,
            color: NAV_BAR_COLORS.APP_TILE_ICON_COLOR,
          }}
        />
      </Flex>

      <Text
        fontSize={NAV_BAR_TYPOGRAPHY.LABEL_FONT_SIZE}
        fontWeight={NAV_BAR_TYPOGRAPHY.APP_NAME_FONT_WEIGHT}
        c={NAV_BAR_COLORS.APP_TILE_NAME}
      >
        {app.name}
      </Text>

      {app.isWaitlisted && (
        <Box
          component="span"
          sx={{
            px: NAV_BAR_LAYOUT.APP_WAITLIST_PADDING,
            borderRadius: NAV_BAR_LAYOUT.APP_WAITLIST_RADIUS,
            bgcolor: NAV_BAR_COLORS.APP_WAITLIST_BG,
            color: NAV_BAR_COLORS.APP_WAITLIST_TEXT,
            fontSize: NAV_BAR_TYPOGRAPHY.CAPTION_FONT_SIZE,
            fontWeight: NAV_BAR_TYPOGRAPHY.APP_NAME_FONT_WEIGHT,
            letterSpacing: NAV_BAR_TYPOGRAPHY.OVERLINE_LETTER_SPACING,
            textTransform: "uppercase",
          }}
        >
          {NAV_BAR_LABELS.APP_WAITLIST}
        </Box>
      )}
    </Flex>
  );
};

export default AppSwitcherTile;
